/* Pluvion Custom Fixes */
(function () {

  /* ========== 1. KLEUR LABEL UPDATE ========== */
  function initColorSwatches() {
    document.querySelectorAll('.pluvion-product__color-input').forEach(function (input) {
      if (input.dataset.swatchBound) return;
      input.dataset.swatchBound = '1';
      input.addEventListener('change', function () {
        var optionDiv = this.closest('.pluvion-product__option');
        if (optionDiv) {
          var span = optionDiv.querySelector('.pluvion-product__option-value');
          if (span) span.textContent = this.value;
        }
        var swatchesDiv = this.closest('.pluvion-product__color-swatches');
        if (swatchesDiv) {
          swatchesDiv.querySelectorAll('.pluvion-product__color-swatch').forEach(function (s) {
            s.classList.remove('is-selected');
          });
          var parentSwatch = this.closest('.pluvion-product__color-swatch');
          if (parentSwatch) parentSwatch.classList.add('is-selected');
        }
      });
    });
  }

  /* ========== INIT ========== */
  function init() {
    initColorSwatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

})();
